import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

const Testimonials = () => {
  const { t } = useTranslation();
  const tm = t('home.testimonials', { returnObjects: true });

  return (
    <section data-testid="testimonials" className="py-16 md:py-24 border-t border-white/5">
      <div className="container-custom max-w-4xl">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-['Syne'] text-white">{tm.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tm.items.map((item, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="p-6 rounded-2xl border border-white/10 bg-white/[0.02]">
              <div className="flex gap-0.5 mb-4">{[1,2,3,4,5].map(s => <Star key={s} className="w-4 h-4 text-[#c8ff00] fill-[#c8ff00]" />)}</div>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">"{item.quote}"</p>
              <p className="text-white font-bold text-sm">{item.author}</p>
              <p className="text-gray-500 text-xs">{item.location}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-white/50 text-sm mb-4">{tm.ctaText}</p>
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
            <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#c8ff00] text-black font-bold rounded-full hover:bg-[#d4ff33] transition-colors">
              {tm.cta}
              <ArrowRight className="w-4 h-4" />
            </motion.span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
